var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#38c396;}.cls-2{fill:#65deb4;}.cls-3{fill:#bcefdd;}.cls-4{fill:#00765c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-1",
    d: "M30.53,119a2,2,0,0,0-2,2v99.61a2,2,0,0,0,2.94,1.79L84.7,203.16l.33.13V119Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-name": "Vector 2",
    className: "cls-2",
    d: "M138.86,119H85v84.28l52.91,19.12a2,2,0,0,0,2.93-1.79V121A2,2,0,0,0,138.86,119Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    "data-name": "Vector 3",
    className: "cls-3",
    d: "M85,10.74c-8.32,0-18-9.42-25.56-7C51.66,6.27,49.36,19.69,42.88,24.39s-20,2.82-24.77,9.36,1.25,18.64-1.29,26.42C14.4,67.68,2.33,74,2.33,82.29S14.4,96.91,16.84,104.41c2.52,7.77-3.45,19.94,1.28,26.42s18.23,4.61,24.77,9.35,8.78,18.13,16.56,20.64c7.51,2.44,17.23-7,25.56-7s18,9.43,25.56,7c7.79-2.51,10.09-15.93,16.56-20.64s20-2.82,24.78-9.35-1.26-18.65,1.28-26.42c2.41-7.5,14.48-13.8,14.48-22.12S155.6,67.68,153.16,60.18c-2.52-7.77,3.45-19.94-1.28-26.42s-18.23-4.61-24.77-9.35S118.33,6.28,110.55,3.77C103,1.32,93.32,10.74,85,10.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    "data-name": "Vector 4",
    className: "cls-1",
    d: "M85,139.4a57.11,57.11,0,1,1,57.18-57.11A57.21,57.21,0,0,1,85,139.4ZM85,30.69a51.6,51.6,0,1,0,51.67,51.6A51.7,51.7,0,0,0,85,30.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/Ribbon.2dd5cdb4b447542f9cd001678e6918cd.svg";
export { ForwardRef as ReactComponent };